import { assign } from "xstate";
import {
  IContext,
  ISelectFileEvent,
  ISetDownloadUrl,
  ISetUploadedFileName,
  ISetUploadProgress,
  ISubmitFileForm,
} from "./types";

export const selectFile = assign<IContext, ISelectFileEvent>({
  file: (_ctx, event) => event.file,
});

export const submitFileForm = assign<IContext, ISubmitFileForm>({
  userEmail: (_ctx, event) => event.userEmail,
});

export const resetFile = assign<IContext, any>({
  file: undefined,
});

export const setUploadedFileName = assign<IContext, ISetUploadedFileName>({
  uploadedFileName: (_ctx, event) => event.fileName,
});

export const setUploadStatus = assign<IContext, ISetUploadProgress>({
  originalFileUploadStatus: (_ctx, event) => event.status.original,
  repairedFileUploadStatus: (_ctx, event) => event.status.repaired,
});

export const setDownloadUrl = assign<IContext, ISetDownloadUrl>({
  repairedFileDownloadUrl: (_ctx, event) => event.url,
});
